import type { GameDefinition, RunMode } from '../games/core/types';

export type SkipState = {
  visible: boolean;
  available: boolean;
  remainingMs: number;
};

export function getSkipState(
  mode: RunMode,
  skip: GameDefinition['skip'],
  rawActiveMs: number,
): SkipState {
  const delayMs = mode === 'practice' ? skip.practiceDelayMs : skip.competitiveDelayMs;
  if (delayMs === null) return { visible: false, available: false, remainingMs: 0 };
  const remainingMs = Math.max(0, delayMs - rawActiveMs);
  return { visible: true, available: remainingMs === 0, remainingMs };
}
